import NoDataTemplate from "common/components/NoDataTemplate"
import { TFunction } from "i18next"
import activoDetailEmpty from "../../assets/activoDetailEmpty.svg"

export const TablaActivoIdEmptyTemplate = ({
  t,
  action,
}: {
  t: TFunction
  action: () => void
}) => (
  <NoDataTemplate
    icon={activoDetailEmpty}
    title={`${t("nsAssets.tabAmortizable.nonAmortizableTitle")}`}
    description={`${t("nsAssets.tabAmortizable.nonAmortizableSubtitle")}`}
    actionLabel={`${t("nsAssets.tabAmortizable.assetAmortize")}`}
    actionCommand={action}
  />
)
